import React from 'react';
import {Link} from "@reach/router";
import AppState from 'js/stores/AppState';
import userCountry from 'js/services/UserCountry';
import analytics from 'js/services/Analytics';
import { formatCurrency } from 'js/services/Format';
import UserCountry from 'js/services/UserCountry';

const HeroButtons = ({mseller, activationHandler}) => {


  return(
    <div className="pod-hero-buttons d-flex justify-content-start align-items-stretch">
      <div className="pod-hero-button">
        <Link to={'/login/'} className="btn btn-lg btn-pod btn-primary btn-activate-store" onClick={activationHandler}>
          { userCountry() === 'NG' && 'Activate your Checkout'}
          { userCountry() !== 'NG' && 'Activate your Store'}
        </Link>
      </div>
    </div>
  );
}

export default HeroButtons;
